import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import FormClientView from '../views/FormClientView.vue'

const routes = [
  {
    path: '/:m&:c&:p&:i',
    name: 'Abonnements',
    component: HomeView,
    props: route => ({query: route.query.q})
  },
  {
    path: '/inscription/:c',
    name: 'FormulaireClient',
    component: FormClientView,
    beforeEnter: (to, from, next) => {
      if (to.params.c === 'braderie') {
        next()
      } else {
        next({ name: 'not-found' })
      }
    }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import("@/views/PageNotFound.vue"),
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
